module.exports = __webpack_public_path__ + "img/nejm_nejm_logo-old.f5cf8aa2.png";